export default __webpack_public_path__ + "static/media/Submitted.976c6a51.svg";